<template>
<div>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-input placeholder="输代理商名" v-model="info" style="width:200px"></el-input>
                <el-button type="primary" @click="search()">查询</el-button>
                <el-button type="primary" @click="exportTable()">导出EXCEL</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <el-table :data="tableData" border v-loading="listLoading" style="width: 100%;margin-top:5px;">
        <el-table-column sortable prop="servicename" label="代理商名称" min-width="150">
        </el-table-column>
        <el-table-column prop="rechargesum" label="充值数量" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="rechargeprice" label="充值总额(元)" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="rechargemonth" label="月份" min-width="150" sortable>
        </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar" style="text-align:right">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-col>
    <!-- 弹窗显示信息 -->
    <el-dialog title="充值汇总详细" :visible.sync="userInfoFormVisible" :close-on-click-modal="true">
        <div style="overflow: auto; width: 100%;">
            <table class="border-table">
                <tr>
                    <td class="spec alt">代理商名称:</td>
                    <td>{{infowindow.servicename}}</td>
                    <td class="alt spec">充值数量:</td>
                    <td>{{infowindow.rechargesum}}</td>
                </tr>
                <tr>
                    <td class="spec alt">充值总额:</td>
                    <td>{{infowindow.rechargeprice}}元</td>
                    <td class="alt spec">充值月份:</td>
                    <td>{{infowindow.rechargemonth}}</td>
                </tr>
            </table>
        </div>
    </el-dialog>

</div>
</template>

<script>
import {
    getSummaryList
} from '../../api/api'
export default {

    data() {
        return {
            //弹窗的显示状态
            userInfoFormVisible: false,
            currentPage: 1, //当前页
            total: 200, //数据条数
            pageSize: 10,
            listLoading: false,
            info: '',
            tableData: [], //表格
            infowindow: {
                servicename: '',
                rechargesum: 0,
                rechargeprice: 0,
                rechargemonth: '',

            }
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        //修改每页的条数
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },
        handleCurrentChange(val) {
            //换页查询数据
            this.currentPage = val;
            this.getList();
        },
        getList() {

            let para = {
                info: this.info,
                pageSize: this.pageSize,
                pageNum: this.currentPage,
            };
            this.listLoading = true;
            getSummaryList(para).then((res) => {

                this.tableData = res.data.list;
                this.total = res.data.total;
                this.listLoading = false;
            });

        },
        search() {
            //查询时把当前页变为1
            this.currentPage = 1;
            //重新查询数据
            this.getList();
        },
        //导出表数据
        exportTable() {
            location.href = "/api/summary/exportSummary?info=" + this.info;
        }
    }
}
</script>

<style>
.border-table {
    border-collapse: collapse;
    border: none;
    width: 100%;
}

.border-table td {
    border: solid #dfe8ec 1px;
    background: #fff;
    font-size: 14px;
    padding: 12px 1px 12px 12px;
    color: #009966;
    line-height: 28px;
}

td.alt {
    background: #EFF2F7;
    color: #8492A6;
}

.alt {
    width: 200px;
}
</style>



// WEBPACK FOOTER //
// recharge_summary.vue?654b479a